import qs, { IParseOptions } from 'qs';
import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

type QueryParams = {
  readonly key: string;
  readonly value?: string;
};

const options: IParseOptions = {
  ignoreQueryPrefix: true,
  plainObjects: true,
  interpretNumericEntities: true,
  decoder: (str, defaultDecoder, charset, type) => {
    const decoded = defaultDecoder(str, defaultDecoder, charset);
    if (type === 'value') {
      if (!isNaN(Number(decoded))) {
        return Number(decoded);
      }
    }
    return decoded;
  },
};

/**
 * Update/Set search param without deleting other params
 */
export const useSetSearchParams = () => {
  const [, internalSetSearchParams] = useSearchParams();
  const location = useLocation();

  const setSearchParams = useCallback(
    (queryParams: QueryParams[]) => {
      internalSetSearchParams(() => {
        const currentState = qs.parse(location.search, options);
        queryParams.forEach(({ key, value }) => {
          if (value) {
            currentState[key] = value;
          } else {
            delete currentState[key];
          }
        });
        return qs.stringify(currentState);
      });
    },
    [location.search, internalSetSearchParams],
  );

  return {
    setSearchParams,
  };
};
